(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const footerLinkLists = [...this.closest('.footer')?.querySelectorAll('footer-menu')];

        const currentIndex = footerLinkLists.findIndex((item) => item === this);
        const isLastBlock = currentIndex + 1 === footerLinkLists.length;

        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter || isLastBlock;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["link-lists"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class LinkListCard extends DetailsDisclosure {
      constructor() {
        super();
        this.setStateForViewport();
        window.addEventListener('on:breakpoint-change', this.setStateForViewport.bind(this));
      }

      /**
       * Keeps the link list expanded on desktop and collapsed on mobile.
       */
      setStateForViewport() {
        const isDesktop = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isDesktop;

        if (isDesktop) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('link-list-card', LinkListCard);
  });

  } catch(e) { console.error(e); }
})();
})();
